import React from 'react';
import { Linkedin } from 'lucide-react';
import { initiateLinkedInLogin } from '../lib/linkedin';

interface LinkedInLoginButtonProps {
  className?: string;
  onSuccess?: (user: any) => void;
  onError?: (error: string) => void;
}

const LinkedInLoginButton: React.FC<LinkedInLoginButtonProps> = ({ 
  className = '',
  onSuccess,
  onError 
}) => {
  const handleClick = async () => {
    try {
      await initiateLinkedInLogin();
      // Success handling happens in the callback
    } catch (error: any) {
      if (onError) {
        onError(error.message || 'Erreur lors de la connexion avec LinkedIn');
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center justify-center space-x-2 bg-[#0A66C2] text-white px-4 py-2 rounded-md hover:bg-[#004182] transition-colors ${className}`}
    >
      <Linkedin className="w-5 h-5" />
      <span>Se connecter avec LinkedIn</span>
    </button>
  );
};

export default LinkedInLoginButton;